import companyFrag from "./Company";
import contactAddress from "./ContactAddress";
import contactArtist from "./ContactArtist";
import contactFocus from "./ContactFocus";
import contactMailingList from "./ContactMailingList";
import contactNumber from "./ContactNumber";
import ContactType from "./ContactType";
import Country from "./Country";
import Entity from "./Entity";
import item from "./Item";
import request from "./Request";
import offerFrag from "./Offer";

const Contact = (props = {}) => {
  // Handle case where props is true (include defaults) vs object (use configured fields)
  const includeDefaults = props === true || Object.keys(props).length === 0;
  const propsObj = typeof props === "object" && props !== null ? props : {};

  const {
    artistIDs = includeDefaults,
    contactAddresses = false,
    contactArtists = false,
    contactLinks = false,
    contactCompany = includeDefaults,
    contactFocuses = false,
    contactMailingLists = false,
    contactNumbers = includeDefaults,
    country = includeDefaults,
    documents = false,
    exhUser = false,
    firstUser = false,
    purchases = false,
    purchasesTotal = false,
    offer = false,
    requests = false,
    salesUser = false,
    salesUser2 = false,
    type = false,
    type2 = false,
    address = includeDefaults,
    address2 = includeDefaults,
    address3 = includeDefaults,
    affiliations = includeDefaults,
    biography = includeDefaults,
    collection = includeDefaults,
    collectionActive = includeDefaults,
    company = includeDefaults,
    confidential = includeDefaults,
    contactSecondary = includeDefaults,
    countryId = includeDefaults,
    county = includeDefaults,
    createdAt = includeDefaults,
    dateEntered = includeDefaults,
    details = includeDefaults,
    dob = includeDefaults,
    email = includeDefaults,
    eori = includeDefaults,
    exhUserId = includeDefaults,
    firstcontactdate = includeDefaults,
    firstcontactlocation = includeDefaults,
    firstcontacttype = includeDefaults,
    firstUserId = includeDefaults,
    forename = includeDefaults,
    greeting = includeDefaults,
    img = includeDefaults,
    invoicesLength = includeDefaults,
    level = includeDefaults,
    mailingname = includeDefaults,
    middlename = includeDefaults,
    name = includeDefaults,
    notes = includeDefaults,
    postcode = includeDefaults,
    prefered = includeDefaults,
    rating = includeDefaults,
    sagecode = includeDefaults,
    salesForceId = includeDefaults,
    salesUserId = includeDefaults,
    salesUser2Id = includeDefaults,
    salutation = includeDefaults,
    siteId = includeDefaults,
    storageCharge = includeDefaults,
    surname = includeDefaults,
    title = includeDefaults,
    totalSpend = includeDefaults,
    town = includeDefaults,
    typeId = includeDefaults,
    type2Id = includeDefaults,
    unsubscribed = includeDefaults,
    updatedAt = includeDefaults,
    userEntered = includeDefaults,
    user = includeDefaults,
    vat = includeDefaults,
  } = propsObj;

  return `
  id
  ${address ? `address` : ""}
  ${address2 ? `address2` : ""}
  ${address3 ? `address3` : ""}
  ${affiliations ? `affiliations` : ""}
  ${artistIDs ? `artistIDs` : ""}
  ${biography ? `biography` : ""}
  ${collection ? `collection` : ""}
  ${collectionActive ? `collectionActive` : ""}
  ${company ? `company` : ""}
  ${confidential ? `confidential` : ""}
  ${
    contactAddresses
      ? `contactAddresses {
      ${contactAddress(contactAddresses)}
    }`
      : ""
  }
  ${
    contactArtists
      ? `contactArtists {
      ${contactArtist(contactArtists)}
    }`
      : ""
  }
  ${
    contactLinks
      ? `contactLinks {
      id
      contactId
      description
      expired
      link {
        id
        name
      }
      linkId
      type {
        id
        description
      }
      typeId
      updatedAt
    }`
      : ""
  }
  ${
    contactCompany
      ? `contactCompany {
      ${companyFrag({
        consignmentTerms: false,
        loanTerms: false,
        ...(typeof contactCompany === "object" ? contactCompany : {}),
      })}
    }`
      : ""
  }
  ${
    contactFocuses
      ? `contactFocuses {
      ${contactFocus(contactFocuses)}
    }`
      : ""
  }
  ${
    contactMailingLists
      ? `contactMailingLists {
      ${contactMailingList(contactMailingLists)}
    }`
      : ""
  }
  ${
    contactNumbers
      ? `contactNumbers {
      ${contactNumber(contactNumbers)}
    }`
      : ""
  }
  ${contactSecondary ? `contactSecondary` : ""}
  ${countryId ? `countryId` : ""}
  ${
    country
      ? `country {
      ${Country}
    }`
      : ""
  }
  ${county ? `county` : ""}
  ${createdAt ? `createdAt` : ""}
  ${dateEntered ? `dateEntered` : ""}
  ${details ? `details` : ""}
  ${dob ? `dob` : ""}
  ${documents ? "documents" : ""}
  ${email ? `email` : ""}
  ${eori ? `eori` : ""}
  ${
    exhUser
      ? `exhUser {
      ${Entity}
    }`
      : ""
  }
  ${exhUserId ? `exhUserId` : ""}
  ${firstcontactdate ? `firstcontactdate` : ""}
  ${firstcontactlocation ? `firstcontactlocation` : ""}
  ${firstcontacttype ? `firstcontacttype` : ""}
  ${
    firstUser
      ? `firstUser {
      ${Entity}
    }`
      : ""
  }
  ${firstUserId ? `firstUserId` : ""}
  ${forename ? `forename` : ""}
  ${greeting ? `greeting` : ""}
  ${img ? `img` : ""}
  ${invoicesLength ? `invoicesLength` : ""}
  ${level ? `level` : ""}
  ${mailingname ? `mailingname` : ""}
  ${middlename ? `middlename` : ""}
  ${name ? `name` : ""}
  ${
    offer
      ? `offer {
      ${offerFrag(offer)}
    }`
      : ""
  }
  ${notes ? `notes` : ""}
  ${postcode ? `postcode` : ""}
  ${prefered ? `prefered` : ""}
  ${
    purchases
      ? `purchases {
      ${item(purchases)}
    }`
      : ""
  }
  ${
    purchases || purchasesTotal
      ? `purchasesTotal {
      converted
      original
    }`
      : ""
  }
  ${rating ? `rating` : ""}
  ${
    requests
      ? `requests {
      ${request(requests)}
    }`
      : ""
  }
  ${sagecode ? `sagecode` : ""}
  ${salesForceId ? `salesForceId` : ""}
  ${
    salesUser
      ? `salesUser {
      ${Entity}
    }`
      : ""
  }
  ${salesUserId ? `salesUserId` : ""}
  ${
    salesUser2
      ? `salesUser2 {
      ${Entity}
    }`
      : ""
  }
  ${salesUser2Id ? `salesUser2Id` : ""}
  ${salutation ? `salutation` : ""}
  ${siteId ? `siteId` : ""}
  ${storageCharge ? `storageCharge` : ""}
  ${surname ? `surname` : ""}
  ${title ? `title` : ""}
  ${totalSpend ? `totalSpend` : ""}
  ${town ? `town` : ""}
  ${
    type
      ? `type {
      ${ContactType}
    }`
      : ""
  }
  ${typeId ? `typeId` : ""}
  ${
    type2
      ? `type2 {
      ${ContactType}
    }`
      : ""
  }
  ${type2Id ? `type2Id` : ""}
  ${unsubscribed ? `unsubscribed` : ""}
  ${updatedAt ? `updatedAt` : ""}
  ${userEntered ? `userEntered` : ""}
  ${user ? `user` : ""}
  ${vat ? `vat` : ""}
`;
};

// const ContactTable = `

//   companyName: company
//   country {
//     ${Country}
//   }
//   county
//   email
//   img
//   name
//   salesUser {
//     ${Entity}
//   }
//   title
//   type {
//     ${ContactType}
//   }
//   unsubscribed
// `

export default Contact;
